/** HubUP dans les emails : compte CRM lié à au moins une communauté (ou campagne avec groupe). */
export function canUseHubupEmailFeatures(user, campaign) {
  if (user?.permission === 'admin') return true;
  if (!user?.hubup) return false;
  const ids = Array.isArray(user.hubupCommunityIds)
    ? user.hubupCommunityIds.filter(Boolean)
    : [];
  if (ids.length > 0) return true;
  const groupId = String(campaign?.hubupGroupId || '').trim();
  return Boolean(groupId);
}

/** Rédaction du mail campagne (brouillon) : design + variables sans exiger la commu déjà affectée. */
export function canComposeHubupCampaignEmail(user) {
  return user?.permission === 'admin' || Boolean(user?.hubup);
}
